import { isJapaneseHoliday } from "@chillnn-core/holiday-jp";
import { memo, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";
import { dayOfTheWeekConverter } from "@/lib/chillnn/day-of-the-week-converter";
import { DayOfTheWeek, LangCode } from "@/lib/gql/__generated__/graphql";

import { TableHead } from "@/components/ui/table/table";

type Props = {
	date: string;
	weekday: DayOfTheWeek;
};

export const StockTableHeaderItem = memo(({ date, weekday }: Props) => {
	const holiday = useMemo(() => isJapaneseHoliday(new Date(date)), [date]);

	return (
		<TableHead className="w-20 bg-white" justifyStyle={"center"}>
			<div className="flex flex-col items-center">
				{/* 日にち */}
				<p className={cn("tabular-nums text-zinc-950")}>{Number(date.split("-")[2])}</p>
				{/* 曜日（祝日の場合は日曜と同じ色） */}
				<p
					className={cn(
						"text-zinc-950",
						weekday === DayOfTheWeek.Sat && !holiday && "text-edited",
						(weekday === DayOfTheWeek.Sun || holiday) && "text-not-entered",
					)}
				>
					{dayOfTheWeekConverter(weekday, LangCode.Default)}
				</p>
			</div>
		</TableHead>
	);
});

StockTableHeaderItem.displayName = "StockTableHeaderItem";
